
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { IIntegrationElement } from "@/dtos/IIntegrationElement";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
  name: "RestaurantStatusBanner",
  setup() {
    const store = useStore();
    const statuses = ref<any[]>([]);
    const loading = ref(false);
    const busy = ref(false);
    let timer: any = null;

    const name = (t: number) =>
      IIntegrationElement.friendlyName({ integrationType: t } as any);

    const fetchStatus = async () => {
      loading.value = true;
      const data: any = await store.dispatch(Actions.RESTAURANT_STATUS);
      statuses.value = Array.isArray(data) ? data : [];
      loading.value = false;
    };

    const toggle = async (s: any) => {
      const willOpen = !s.open;
      const res = await Swal.fire({
        title: `${name(s.integrationType)} dükkanını ${
          willOpen ? "açmak" : "kapatmak"
        } istediğinize emin misiniz?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: willOpen ? "Evet, aç" : "Evet, kapat",
        cancelButtonText: "Vazgeç",
        confirmButtonColor: willOpen ? "#50cd89" : "#d33",
      });
      if (!res.value) return; // SweetAlert2 v9: confirm -> res.value
      busy.value = true;
      const ok = await store.dispatch(Actions.SET_RESTAURANT_STATUS, {
        integrationId: s.integrationId,
        open: willOpen,
      });
      busy.value = false;
      if (ok) {
        s.open = willOpen;
        s.status = willOpen ? "OPEN" : "CLOSED";
        Swal.fire({
          title: "Güncellendi",
          icon: "success",
          timer: 1200,
          showConfirmButton: false,
        });
        fetchStatus();
      } else {
        Swal.fire({
          title: "Hata",
          text: "Durum güncellenemedi. Lütfen tekrar deneyin.",
          icon: "error",
          confirmButtonText: "Tamam",
        });
      }
    };

    onMounted(() => {
      fetchStatus();
      timer = setInterval(fetchStatus, 60000); // periyodik durum güncelleme
    });
    onUnmounted(() => {
      if (timer) clearInterval(timer);
    });

    return { statuses, loading, busy, name, toggle };
  },
});
